<template>
    <font-awesome-icon class="fill-current" :icon="icon" />
</template>

<script setup lang="ts">
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';
// eslint-disable-next-line import/no-unresolved
import {byPrefixAndName} from '@awesome.me/kit-4bfc2309f5/icons';
import {computed} from 'vue';
import type {IconName} from '@/shared/types/icon';

type Props = {
    name: IconName;
    solid?: boolean;
};

const props = defineProps<Props>();

const iconPrefix = computed(() => (props.solid ? 'fas' : 'far'));

const icon = computed(() => {
    const prefix = iconPrefix.value;
    const requestedIcon = byPrefixAndName[prefix]?.[props.name];

    // Fallback to 'notdef' icon if requested icon doesn't exist
    if (!requestedIcon) {
        return byPrefixAndName[prefix]?.['notdef'] || byPrefixAndName['far']?.['notdef'];
    }

    return requestedIcon;
});
</script>
